if (!customElements.get('alma-cart-availability')) {
  customElements.define('alma-cart-availability', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.check(this.controller.signal);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async check(signal) {
      const items = [...this.querySelectorAll('[data-handle]')];
      const handles = [...new Set(items.map(item => item.dataset.handle).filter(Boolean))];
      const products = new Map();
      const root = this.dataset.root || '/';
      const request = async handle => {
        const timeout = new AbortController();
        const abort = () => timeout.abort();
        signal.addEventListener('abort', abort, { once: true });
        const timer = setTimeout(abort, 8000);
        try {
          const url = new URL(`${root}products/${encodeURIComponent(handle)}.js`, location.origin);
          if (url.origin !== location.origin) return;
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: timeout.signal });
          if (response.status === 404) products.set(handle, null);
          else if (response.ok) products.set(handle, await response.json());
        } catch (error) {
          if (error.name !== 'AbortError') products.delete(handle);
        } finally {
          clearTimeout(timer);
          signal.removeEventListener('abort', abort);
        }
      };
      let next = 0;
      await Promise.all(Array.from({ length: Math.min(4, handles.length) }, async () => {
        while (next < handles.length && !signal.aborted) await request(handles[next++]);
      }));
      if (signal.aborted || !this.isConnected) return;
      const list = this.querySelector('[data-cart-warning-list]');
      list.replaceChildren();
      for (const item of items) {
        const handle = item.dataset.handle;
        if (!products.has(handle)) continue;
        const product = products.get(handle);
        const variant = product?.variants?.find(v => String(v.id) === item.dataset.variant);
        const optionUnavailable = Array.isArray(product?.variants) && (!variant || !variant.available);
        const message = product === null ? this.dataset.unavailable : optionUnavailable ? this.dataset.variantUnavailable : null;
        if (!message) continue;
        const li = document.createElement('li');
        li.textContent = message.replace('__PRODUCT__', item.dataset.title);
        list.append(li);
      }
      this.querySelector('[data-cart-warning]').hidden = !list.children.length;
    }
  });
}
